import React, { Component } from 'react';
import { Nav, NavItem, NavLink, Collapse, Card, CardBody } from 'reactstrap';

class SettingsSidebar extends Component {
  state = {
    // Map of section key -> explicitly toggled open/closed state.
    open: {},
  };

  isOpen(sectionKey) {
    const { open } = this.state;
    const { selected } = this.props;
    if (Object.prototype.hasOwnProperty.call(open, sectionKey)) {
      return open[sectionKey];
    }
    // Default: the section holding the active subject starts expanded.
    return selected && selected.section === sectionKey;
  }

  toggleSection = (sectionKey) => {
    this.setState((state) => ({
      open: { ...state.open, [sectionKey]: !this.isOpen(sectionKey) },
    }));
  };

  render() {
    const { menu = [], selected, onSelect } = this.props;

    return (
      <Card>
        <CardBody className="p-2">
          <Nav vertical>
            {menu.map((section) => {
              const open = this.isOpen(section.key);
              return (
                <div key={section.key}>
                  <NavItem>
                    <NavLink
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleSection(section.key);
                      }}
                      style={{ fontWeight: 600, cursor: 'pointer' }}
                    >
                      <i
                        className={
                          'now-ui-icons ' +
                          (open
                            ? 'arrows-1_minimal-down'
                            : 'arrows-1_minimal-right')
                        }
                        style={{ marginRight: '8px', fontSize: '11px' }}
                      />
                      {section.title}
                    </NavLink>
                  </NavItem>
                  <Collapse isOpen={open}>
                    <Nav vertical className="ml-3">
                      {(section.subjects || []).map((subject) => {
                        const active =
                          selected &&
                          selected.section === section.key &&
                          selected.subject === subject.key;
                        return (
                          <NavItem key={subject.key}>
                            <NavLink
                              href="#"
                              active={active}
                              onClick={(e) => {
                                e.preventDefault();
                                onSelect(section.key, subject.key);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              {subject.title}
                            </NavLink>
                          </NavItem>
                        );
                      })}
                    </Nav>
                  </Collapse>
                </div>
              );
            })}
          </Nav>
        </CardBody>
      </Card>
    );
  }
}

export default SettingsSidebar;
